import React from 'react';
import { Banner } from 'Shared/util/types';
import { useTranslation } from 'Shared/util/custom-hooks';
import BaseBanner from 'Shared/components/banners/base-banner';
import Description from 'Shared/components/description';
import InlineSvg from 'Shared/components/inline-svg';
import styles from './fortnox-reminder-banner.css';


type FortnoxReminderBannerProps = {
  numberOfInvoices: number;
};

const FortnoxReminderBanner = ({
  numberOfInvoices,
}: FortnoxReminderBannerProps) => {
  const t = useTranslation(x => x.fortnox.banner_reminder);
  const tg = useTranslation(x => x.global);

  return (
    <BaseBanner
      id={Banner.UseIntegrationReminderFortnox}
      render={() => (
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <h2>{t.simplify_invoice_flow}</h2>
            <InlineSvg src="/integration/fortnox.svg" className={styles.svgContainer} />
          </div>
          <Description
            text={t.format(t.recently_submitted_invoices, {
              numberOfInvoices1: numberOfInvoices,
              numberOfInvoices2: (numberOfInvoices > 1 ? tg.invoicesPlural : tg.invoicesSingular)
            })}
            className={styles.description}
          />
        </div>
      )}
    />
  );
};

export default FortnoxReminderBanner;
